<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Dependentes</h2>
                    </div>
                    <div class="menu-painel">
                        <button mat-stroked-button color="primary" (click)="add()" matTooltip="Criar">Novo
                        </button>
                    </div>
                </div>
                <div class="panel-body" (window:resize)="onResize($event)">

                    <form [formGroup]="formularioDeConsultaDeDependente" (ngSubmit)="onSubmit()">

                        <div class="form-row">
                            <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-8 col-12">
                                <mat-label>Dependente</mat-label>
                                <input matInput value="Dependente" class="form-control" id="nome" trim="blur"
                                    name="nome" formControlName="nome" maxlength="60" upperCase>

                                <mat-error *ngIf="formularioDeConsultaDeDependente.controls.nome.hasError('minlength')">
                                    O campo Dependente precisa conter mais do que 2 caracteres.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                                <mat-label>Data Nasc.</mat-label>
                                <input matInput [matDatepicker]="dataNascimentoDP" formControlName="dataNascimento"
                                    id="dataNascimento" name="dataNascimento">
                                <mat-datepicker-toggle matSuffix [for]="dataNascimentoDP"></mat-datepicker-toggle>
                                <mat-datepicker #dataNascimentoDP></mat-datepicker>

                                <mat-error
                                    *ngIf="formularioDeConsultaDeDependente.controls.dataNascimento.hasError('invalidDate')">
                                    O campo Data Nasc. está inválido.
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-8 col-12">
                                <mat-label>Responsável</mat-label>
                                <input matInput value="Responsável" class="form-control" id="responsavel" trim="blur"
                                    name="responsavel" formControlName="responsavel" maxlength="60" upperCase>

                                <mat-error
                                    *ngIf="formularioDeConsultaDeDependente.controls.responsavel.hasError('minlength')">
                                    O campo Responsável precisa conter mais do que 2 caracteres.
                                </mat-error>
                            </mat-form-field>

                            <div class="form-group col-lg-2 col-md-4 col-sm-4 col-12" style="align-self: center;">
                                <button mat-raised-button color="success" type="submit" matTooltip="Consultar"
                                    [disabled]="!formularioDeConsultaDeDependente.valid" style="width: 100%;">
                                    Consultar
                                </button>
                            </div>
                        </div>

                    </form>

                    <table mat-table [dataSource]="dataSource" matSort class="table table-striped">
                        <ng-container matColumnDef="dependente">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Dependente </th>
                            <td mat-cell *matCellDef="let dependente"> {{dependente.nome}} </td>
                        </ng-container>

                        <ng-container matColumnDef="dataNascimento">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Data Nasc. </th>
                            <td mat-cell *matCellDef="let dependente"> {{dependente.dataNascimento | date:"dd/MM/yyyy"}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="responsavel">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Responsável </th>
                            <td mat-cell *matCellDef="let dependente"> {{dependente.responsavel}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="details">
                            <th mat-header-cell *matHeaderCellDef class="table-column-center"> Ações </th>
                            <td mat-cell *matCellDef="let dependente" class="table-column-center">
                                <button mat-icon-button color="primary" (click)="details(dependente.id)"
                                    matTooltip="Detalhar">
                                    <mat-icon class="mat-18">info</mat-icon>
                                </button>
                                <button mat-icon-button color="primary" (click)="update(dependente.id)"
                                    matTooltip="Alterar">
                                    <mat-icon class="mat-18">edit</mat-icon>
                                </button>
                                <button mat-icon-button color="primary"
                                    (click)="transferirDependenteParaTitular(dependente.id)"
                                    matTooltip="Transferir Titular">
                                    <mat-icon class="mat-18">transfer_within_a_station</mat-icon>
                                </button>
                                <button mat-icon-button color="warn" (click)="confirmDelete(dependente.id)"
                                    matTooltip="Remover">
                                    <mat-icon class="mat-18">delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 30, 50, 70, 100]" showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>